import { useState } from 'react'
import { IconInfoCircle } from '@tabler/icons-react'
//@ts-ignore
import { Button } from 'dsm-react-lib'
import { SmartinsightsIcon, SnowflakeIcon } from '../Chatbot/icons/Icons'
import { Tooltip } from 'react-tooltip'

const QuickActions = () => {
  const [isSubscribed, setIsSubscribed] = useState(false)

  return (
    <div
      className="w-100 p-2 bg-surface rounded-md shadow-sm space-y-4"
      data-testid="quick-actions">
      <h2 className="section-header text-subheading">Quick actions</h2>

      <div className="flex items-center justify-between">
        <span className="flex items-center gap-25 text-lg text-subheading">
          Subscribe <IconInfoCircle size={16} data-tooltip-id="subscribe" />
          <Tooltip
            id="subscribe"
            place="bottom"
            className="rounded-lg px-4 py-2 max-w-xs text-center !z-[9999]">
            Stay informed about any updates or additions to this data product and its details
          </Tooltip>
        </span>
        <input
          id="getLatest"
          className="switch"
          type="checkbox"
          checked={isSubscribed}
          onChange={() => setIsSubscribed(!isSubscribed)}
          data-testid="quick-actions-subscribe-toggle"
        />
      </div>

      <div className="flex flex-col gap-1">
        <Button
          label="Explore"
          color="primary"
          variant="outline"
          className="w-full justify-center dsm-brand-accent"
          data-testid="quick-actions-explore-btn"
        />
        <Button
          label="Query with API"
          color="primary"
          variant="outline"
          className="w-full justify-center dsm-brand-accent"
          data-testid="quick-actions-query-api-btn"
        />
        <Button
          label="Open in SmartInsights"
          color="primary"
          variant="outline"
          className="w-full justify-center dsm-brand-accent"
          icon={<SmartinsightsIcon />}
          data-testid="quick-actions-smartinsights-btn"
        />
        <Button
          label="Open in Snowflake"
          color="info"
          variant="outline"
          className="w-full justify-center"
          icon={<SnowflakeIcon />}
          data-testid="quick-actions-snowflake-btn"
        />
      </div>
    </div>
  )
}
export default QuickActions
